/* OSYN — Suivi de commande (cart drawer).
 * Custom element : survit aux re-renders innerHTML du footer (les éléments
 * recréés se re-connectent seuls, comme cart-note / gift-wrapping de Concept).
 * L'état de vérité = cart attribute (relu par le Liquid au re-rendu) ; ici on
 * ne fait que : bascule optimiste d'aria-checked + POST debouncé vers
 * /cart/update.js (pattern gift-wrapping). Pas de `sections` ni de pubsub :
 * rien d'autre ne dépend de cet attribut, zéro re-render inutile.
 * Le bouton est pré-marqué data-osyn-init côté Liquid → osyn-ui ne s'y
 * attache pas (un seul propriétaire du clic).
 */
(function () {
  'use strict';
  if (window.customElements && customElements.get('osyn-cart-notify')) return;

  var SYNC_EVENT = 'osyn:cart-notify';

  class OsynCartNotify extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-osyn-toggle]');
      if (!this.toggle) return;
      this.toggle.addEventListener('click', this._onToggle.bind(this));
      // Synchro inter-instances : le module existe dans le fold PDP ET dans le
      // drawer — le fold n'étant PAS re-rendu aux updates panier, il se recale
      // via cet événement quand l'autre instance change l'attribut.
      this._onSync = this._syncFrom.bind(this);
      document.addEventListener(SYNC_EVENT, this._onSync);
    }

    disconnectedCallback() {
      // les instances du drawer meurent à chaque re-render : pas de listener fantôme.
      // On ne clear PAS le timer de debounce : un save en vol doit partir même si
      // l'élément meurt (sinon un re-render pendant les 300ms perdrait l'état).
      document.removeEventListener(SYNC_EVENT, this._onSync);
    }

    _syncFrom(event) {
      if (event.detail && event.detail.source === this) return;
      var on = !!(event.detail && event.detail.on);
      if (this.toggle && this.toggle.getAttribute('aria-checked') !== String(on)) {
        this.toggle.setAttribute('aria-checked', String(on));
      }
    }

    _onToggle() {
      if (this.toggle.disabled) return;
      var on = this.toggle.getAttribute('aria-checked') !== 'true';
      this.toggle.setAttribute('aria-checked', String(on)); // optimiste
      this._broadcast(on); // l'autre instance (fold/drawer) suit immédiatement
      clearTimeout(this._t);
      // Closure volontaire : si le footer est re-rendu pendant les 300ms,
      // l'élément meurt mais le POST part quand même → l'état serveur reste
      // juste, le visuel se recale au re-rendu suivant (relit l'attribut).
      var self = this;
      this._t = setTimeout(function () { self._save(on); }, 300);
    }

    _broadcast(on) {
      document.dispatchEvent(new CustomEvent(SYNC_EVENT, { detail: { on: on, source: this } }));
    }

    _save(on) {
      var attributes = {};
      attributes[this.dataset.attribute] = on ? this.dataset.on : this.dataset.off;
      var self = this;
      var body = JSON.stringify({ attributes: attributes });
      fetch(theme.routes.cart_update_url, Object.assign({}, theme.utils.fetchConfig(), { body: body }))
        .then(function (response) { if (!response.ok) throw new Error(response.status); })
        .catch(function () {
          // échec : on revert partout, jamais d'état visuel menteur
          if (self.toggle && self.toggle.isConnected) self.toggle.setAttribute('aria-checked', String(!on));
          self._broadcast(!on);
          console.warn('[osyn-cart-notify] attribut panier non enregistré');
        });
    }
  }

  if (window.customElements) customElements.define('osyn-cart-notify', OsynCartNotify);
})();
